<script setup>
  import { computed } from 'vue';
  import HomeTestimonial from '@/components/HomeTestimonial.vue';
  import BannerAd from '@/components/BannerAd.vue';
  import { useHomeStore } from '@/stores/HomeStore';
  import { useUserStore } from '@/stores/UserStore';
  import useAdConfigurationGlobals from '@/composables/useAdConfigurationGlobals';
  import useConfigurationGlobals from '@/composables/useConfigurationGlobals';

  const { $ADS_ALLOWED } = useAdConfigurationGlobals();
  const { $BRAND } = useConfigurationGlobals();

  const brandClass = `home-brand-${($BRAND || '').toLowerCase()}`;

  const homeStore = useHomeStore();
  const userStore = useUserStore();

  const showAd = computed(() => $ADS_ALLOWED && userStore.showAds);
</script>

<template>
  <!-- Legacy Homepage.master #community-snippets-holder markup, ids and classes preserved.
       Heading is intentionally "iKiteSurf Community" on every brand (and hidden by the
       legacy CSS) — pending a copy decision (spec §7.1). -->
  <div id="community-snippets-holder" :class="brandClass">
    <div id="community-snippets-content" class="wrap">
      <h1>iKiteSurf Community</h1>
      <HomeTestimonial
        v-if="homeStore.testimonial"
        :testimonial="homeStore.testimonial"
      />

      <div v-if="showAd">
        <BannerAd type="header" />
      </div>
    </div>
  </div>
</template>

<style scoped>
  /* Ported from jweather-new-home-common.css + the per-brand new-home.css files */

  #community-snippets-holder {
    padding-top: 1%;
    text-align: center;
    padding-bottom: 20px;
  }

  /* Legacy hides the heading on every brand */
  #community-snippets-content h1 {
    width: 171px;
    height: 69px;
    text-indent: -9999px;
    display: none;
  }

  .wrap {
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
  }

  #community-snippets-holder.home-brand-windalert {
    background: #2a2a2a;
  }

  #community-snippets-holder.home-brand-ikitesurf {
    background: #22beff;
  }

  #community-snippets-holder.home-brand-iwindsurf {
    background: #1875c9;
  }

  #community-snippets-holder.home-brand-sailflow,
  #community-snippets-holder.home-brand-fishweather {
    background: #01253d;
  }
</style>
